import { ContactInfo, PersonInput } from 'sr-types/lib/person/v1/graphql';
import { NameInput, Reference } from 'sr-types/lib/search/v1/graphql';
import { EMAIL_TYPE_STRING } from '../../common/constants/constants';
import { EMAIL_FORMAT_REGEX, validateEmail } from '../../common/form/Validator';
import { ReferenceField } from '../../common/reference/reference';
import { failedToastMessage, successToastMessage } from '../../common/utils/commonUtils';
import { constructContactInfo } from '../detailsPage/detailsPageUtilities/personBasicInformation';
import { PERSON_EMPTY_LAST_NAME } from '../person';

export type AddOptionValue = {
    id: string;
    label: string;
    createOption: boolean;
    ref: ReferenceField;
};

export type QuickAddPerson = {
    id: string;
    name: string;
    label: string;
    role: string;
    productionRole: string;
    reference: ReferenceField;
    contactInfo: ContactInfo;
    email?: string;
};

export type QuickAddPersonOption = {
    id: string;
    name: string | NameInput;
    label: string;
    contactInfo: ContactInfo;
    role: string;
    productionRole: string;
    ref: Reference;
};

export const getPersonOption = (person: QuickAddPerson) => {
    return {
        id: person.id,
        name: person.name,
        label: person.name,
        contactInfo: person.contactInfo,
        role: person.role,
        productionRole: person.productionRole,
        email: person?.email,
        ref: { ...person.reference, label: person.name }
    };
};

const extractQuickPersonInput = (value: string) => {
    const nameParts = value?.trim().split(' ');
    const emailAddress = nameParts.find((label) => EMAIL_FORMAT_REGEX.test(label));
    const contactInfo =
        (emailAddress && constructContactInfo({ email: { address: emailAddress, typeString: '' } })) || null;
    const input: PersonInput = {
        name: {
            firstName: emailAddress || nameParts[0] || '',
            lastName: nameParts.length > 1 && !emailAddress ? nameParts[nameParts.length - 1] : PERSON_EMPTY_LAST_NAME
        },
        contactInfo
    };
    return input;
};
const getContactInfoFromEmailName = (value: string) => {
    return validateEmail(value)
        ? {
              contactInfo: {
                  email: {
                      address: value,
                      typeString: EMAIL_TYPE_STRING.business,
                      verified: false
                  },
                  phone: null
              }
          }
        : {};
};

export const quickAddPerson = (
    value: AddOptionValue,
    save: (value) => Promise<any>,
    returnContactInfo: boolean = false
): Promise<any> => {
    const input: PersonInput = extractQuickPersonInput(value.label);
    return new Promise((resolve, reject) => {
        const savedEntity = { publicTitle: value.label };
        save({
            variables: {
                input
            }
        })
            .then((res) => {
                if (res.data.autoCreatePerson?.errors) {
                    failedToastMessage('form.save.failure', { name: input.name.firstName + '' + input.name.lastName });
                } else {
                    successToastMessage('form.save.success', { name: savedEntity.publicTitle });
                    const { autoCreatePerson } = res.data;
                    const personOption = {
                        id: autoCreatePerson?.id,
                        label: autoCreatePerson?.reference?.label,
                        ref: autoCreatePerson?.reference,
                        name: autoCreatePerson?.reference?.label,
                        ...(returnContactInfo && getContactInfoFromEmailName(value.label))
                    };
                    resolve(personOption);
                }
            })
            .catch((err) => {
                failedToastMessage('form.save.failure', { name: input.name.firstName + '' + input.name.lastName });
                reject(err);
            });
    });
};
